import React from 'react';
import { FileText, Clock, MapPin, CheckCircle2, ShieldCheck, Lock, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-20 px-6 lg:px-8 bg-gradient-to-b from-brand-lighter to-white overflow-hidden" data-id="element-118">
      <div className="max-w-4xl mx-auto text-center" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-light text-brand-accent font-semibold text-sm mb-8" data-id="element-120">
          <span className="w-2 h-2 rounded-full bg-brand-accent animate-pulse" data-id="element-121"></span>
          MEGAPACK AGENTE PRO™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-4xl md:text-6xl font-extrabold text-brand-navy tracking-tight mb-6 leading-tight" data-id="element-122">
          Que la matrícula no sea <br className="hidden md:block" data-id="element-123" />
          <span className="text-brand-accent" data-id="element-124">un adorno en la pared.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-lg md:text-xl text-brand-navy/80 mb-10 max-w-2xl mx-auto font-medium" data-id="element-125">
          El sistema validado para corredores inmobiliarios en Argentina. De
          cero a tu primera venta con un método profesional, no a los
          tropezones.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mb-12" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/v7bBm5qQLK18z6jVFCxgRd/1_(1).webp" alt="MEGAPACK AGENTE PRO — pack de plantillas, guiones y sistemas para corredores inmobiliarios en Argentina" className="w-full max-w-3xl mx-auto h-auto drop-shadow-2xl" data-id="element-127" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 md:gap-8 mb-12 text-brand-navy/80" data-id="element-128">
          <div className="flex items-center justify-center gap-2" data-id="element-129">
            <FileText className="w-5 h-5 text-brand-accent" data-id="element-130" />
            <span data-id="element-131">100% PDF y Excel</span>
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-132">
            <Clock className="w-5 h-5 text-brand-accent" data-id="element-133" />
            <span data-id="element-134">Acceso en 5 min</span>
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-135">
            <MapPin className="w-5 h-5 text-brand-accent" data-id="element-136" />
            <span data-id="element-137">Hecho para Argentina</span>
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-138">
            <CheckCircle2 className="w-5 h-5 text-brand-accent" data-id="element-139" />
            <span data-id="element-140">Con o sin experiencia</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-141">
          <button onClick={scrollToPricing} className="bg-brand-accent hover:bg-blue-700 text-white text-lg font-bold py-4 px-10 rounded-xl shadow-soft-lg hover:shadow-xl transition-all transform hover:-translate-y-1 w-full sm:w-auto" data-id="element-142">
            QUIERO MI MEGAPACK PRO
          </button>

          <div className="flex items-center gap-4 mt-6 text-sm text-brand-navy/60 font-medium" data-id="element-143">
            <div className="flex items-center gap-1" data-id="element-144">
              <ShieldCheck className="w-4 h-4" data-id="element-145" />
              <span data-id="element-146">Garantía 7 días</span>
            </div>
            <span data-id="element-147">·</span>
            <div className="flex items-center gap-1" data-id="element-148">
              <Lock className="w-4 h-4" data-id="element-149" />
              <span data-id="element-150">Pago seguro</span>
            </div>
            <span data-id="element-151">·</span>
            <div className="flex items-center gap-1" data-id="element-152">
              <span className="font-bold text-blue-500" data-id="element-153">mercado</span>
              <span className="font-bold text-blue-900" data-id="element-154">pago</span>
            </div>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-center gap-6 bg-white py-4 px-8 rounded-2xl shadow-soft border border-brand-light" data-id="element-155">
            <div className="flex -space-x-3" data-id="element-156">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-10 h-10 rounded-full bg-brand-light border-2 border-white flex items-center justify-center text-xs font-bold text-brand-accent" data-id="element-157">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>
            <div className="text-left" data-id="element-158">
              <div className="flex items-center gap-1 mb-1" data-id="element-159">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-brand-warm text-brand-warm" data-id="element-160" />)}
                <span className="ml-2 font-bold text-brand-navy" data-id="element-161">4.9/5</span>
              </div>
              <p className="text-sm text-brand-navy/70 font-medium" data-id="element-162">
                <strong className="text-brand-navy" data-id="element-163">+450</strong> corredores
                confían · 6 Módulos · 4 Bonos
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}